import React from 'react';
import { I18n } from 'react-redux-i18n-lite';
import { CustomDonutChart } from '../../common/CustomDonutChart';
import { PropTypes } from 'prop-types';

export class DonutsRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = { diameter: 114 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    if (window.innerWidth <= 768) {
      this.setState({ diameter: 100 });
    } else {
      this.setState({ diameter: 114 });
    }
  }

  static propTypes = {
    chartsData: PropTypes.any
  };

  renderWeeksCharts() {
    let { chartsData } = this.props;
    let donuts = [];
    if (chartsData) {
      chartsData.map((week, index) => {
        let percentClassName;
        let donutClass;
        let icon;
        if (week.average !== null) {
          if (week.average < 50) {
            percentClassName = 'donutchart-danger';
            donutClass = 'red-donut';
          }
          if (week.average >= 50 && week.average < 70) {
            percentClassName = 'donutchart-warning';
            donutClass = 'orange-donut';
          }
          if (week.average >= 70) {
            percentClassName = 'donutchart-success';
            donutClass = 'green-donut';
          }
        } else {
          percentClassName = 'donutchart-empty';
          donutClass = 'gray-donut';
          icon = '...';
        }
        return donuts.push(
          <div key={`${percentClassName}-${donutClass}-${week.average}-${index}`} className="donut-chart-item">
            <CustomDonutChart
              complete={week.average}
              uncompleted={100 - week.average}
              icon={icon}
              label={`${I18n.t('panels.time.week')} ${index + 1}`}
              innerRadius={0.93}
              outerRadius={0.97}
              diameter={this.state.diameter}
              textClassName={'donutchart-text basic-analytics'}
              percentClassName={percentClassName}
              completeClass={donutClass}
            />
          </div>
        );
      });
    }
    return donuts;
  }

  render() {
    return (
      <div className="donuts-row-container">
        {/* The following chart is hidden to prevent blur effect
      on first svg rendering in donut charts*/}
        {this.renderWeeksCharts()}
      </div>
    );
  }
}

export default DonutsRow;
